export default __webpack_public_path__ + "static/media/ivanv_xl.51aeeb08.jpg";